import { Gauge, Eye, ClockCounterClockwise, Broadcast, ChartLineUp, ShieldCheck } from "@phosphor-icons/react";

const impacts = [
  { icon: Gauge,                  label: "Faster inspection",     v: "8.5x",   sub: "vs manual visual QC" },
  { icon: Eye,                    label: "Better visibility",     v: "Live",   sub: "across lines and sites" },
  { icon: ClockCounterClockwise,  label: "Reduced manual effort", v: "-40%",   sub: "supervisor load" },
  { icon: Broadcast,              label: "Fewer missed events",   v: "-72%",   sub: "false-negative rate" },
  { icon: ChartLineUp,            label: "Improved response",     v: "-94%",   sub: "time to plant query" },
  { icon: ShieldCheck,            label: "Streamlined reporting", v: "-80%",   sub: "weekly cycle time" },
];

export default function Impact() {
  return (
    <section data-testid="impact-section" className="px-6 md:px-14 py-24 md:py-32 border-b border-[#2A2A2A]">
      <div className="max-w-6xl">
        <div className="text-overline mb-6">◢ Outcomes — not testimonials</div>
        <h2 className="font-display font-semibold tracking-tighter text-4xl sm:text-5xl text-white leading-[1.05]">
          Impact, <span className="text-[#FF4500]">measured</span>.
        </h2>
      </div>

      <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-px bg-[#2A2A2A] border border-[#2A2A2A]" data-testid="impact-grid">
        {impacts.map((i, idx) => {
          const Icon = i.icon;
          return (
            <div key={idx} data-testid={`impact-${idx}`} className="bg-[#050505] p-8 group hover:bg-[#0a0a0a] transition-colors">
              <Icon size={22} color="#FF4500" weight="duotone" />
              <div className="mt-6 font-display font-bold text-5xl text-white">{i.v}</div>
              <div className="mt-3 font-mono text-[10px] tracking-[0.22em] uppercase text-[#8E8E93]">{i.label}</div>
              <div className="mt-1 text-[#555] text-xs">{i.sub}</div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
